export default {
    buttons: {
        back: 'Previous Page',
        home: 'Go to Home',
    },
};
